<template>
	<div class="wrap-80">
		<div class="info-wrap">
			<div class="info-box" v-loading="loading">
				<div class="info-item">
					<div class="info-head tc">
						<div class="flexCenter">
							<h3>申请企业账号</h3>
							<p class="login-tips flexStart">已有账号？<el-link :underline="false" type="primary" @click="handleLogin" style="font-size: 16px">立即登录</el-link></p>
						</div>

						<p class="info-head-desc">请确保填写的信息准确无误，以便我们尽快完成合作评估并与您联系</p>
					</div>

					<div class="list-box" style="padding: 0 140px 20px">
						<el-form ref="form" :model="form" label-width="180px" :rules="rules" label-position="top">
							<!-- 企业全称 + 企业简称 -->
							<el-row :gutter="40">
								<el-col :span="12">
									<el-form-item label="企业全称：" prop="corporateName">
										<el-input v-model="form.corporateName" placeholder="请输入企业全称" maxlength="100"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业简称：" prop="miniName">
										<el-input v-model="form.miniName" placeholder="请输入企业简称" maxlength="50"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- 企业类型 + 统一社会信用代码 -->
							<el-row :gutter="40">
								<el-col :span="12">
									<el-form-item label="企业类型：" prop="companyType">
										<el-select v-model="form.companyType" placeholder="请选择企业类型" style="width: 100%" clearable>
											<el-option v-for="item in companyTypeOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="统一社会信用代码：" prop="creditCode">
										<el-input v-model="form.creditCode" placeholder="请输入18位统一社会信用代码" maxlength="18"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- 注册地址 -->
							<el-row :gutter="40">
								<el-col :span="24">
									<div>
										<el-form-item class="form-right" label="注册地址：" style="margin-bottom: 0">
											<v-distpicker
												wrapper="distpicker-wrapper"
												:placeholders="placeholders"
												:province="form.provinceName"
												:city="form.cityName"
												:area="form.districtName"
												@selected="onSelected"
												@province="selectChangeProvince"
												@city="selectChangeCity"
												:province-source="provinceSource"
											></v-distpicker>
										</el-form-item>
										<p style="font-size: 12px; color: rgb(245, 108, 108); margin: -16px 0px 0px; margin-left: 180px" v-if="showAddressErrMsg">请选择完整的省市区地址</p>
									</div>
								</el-col>
							</el-row>

							<!-- 企业营业执照复印件 -->
							<el-row :gutter="40">
								<el-col :span="24">
									<el-form-item label="企业营业执照复印件：">
										<div slot="label" class="flexStart field-businessLicense">
											<h3>企业营业执照复印件：</h3>
											<span class="field-hint">上传营业执照（可选），仅用于辅助核验企业身份真实性，有助于提高账户审核效率。</span>
										</div>

										<UploadFileSingle
											ref="businessLicenseRef"
											v-model="businessLicenseFile"
											:fileType="['pdf', 'png', 'jpg', 'jpeg']"
											:limit="1"
											:file-size="10"
											@change="handleBusinessLicenseChange"
										></UploadFileSingle>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- 账号数量需求 -->
							<el-row :gutter="40">
								<el-col :span="12">
									<el-form-item label="账号数量需求：" prop="accNeed">
										<el-select v-model="form.accNeed" placeholder="请选择账号数量需求" style="width: 100%" clearable>
											<el-option v-for="item in accountCountOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="您是如何了解到本网站的？" prop="sourceFind">
										<el-select v-model="form.sourceFind" placeholder="请选择" style="width: 100%" clearable>
											<el-option v-for="item in channelOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<!-- 联系人手机号码 -->
							<el-row :gutter="40">
								<el-col :span="12">
									<el-form-item label="联系人姓名：" prop="contactPerson">
										<el-input v-model="form.contactPerson" placeholder="请输入联系人姓名" maxlength="50"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系人手机号码：" prop="contactPhone">
										<el-input v-model="form.contactPhone" placeholder="请输入您的手机号码以便我们及时联系您" maxlength="11"></el-input>
									</el-form-item>
								</el-col>
								<!-- <el-col :span="12">
									<el-form-item label="手机验证码：" prop="verifyCode">
										<div class="verify-code-input">
											<el-input v-model="form.verifyCode" placeholder="请输入验证码" maxlength="6"></el-input>
											<el-button plain :disabled="waitNum > 0" type="primary" @click="toSendMsg" class="send-code-btn">
												{{ waitNum > 0 ? waitNum + '秒后重发' : '获取验证码' }}
											</el-button>
										</div>
									</el-form-item>
								</el-col> -->
							</el-row>

							<!-- 提交按钮 -->
							<el-row>
								<el-col :span="24">
									<div style="text-align: center; margin-top: 20px">
										<el-button type="primary" @click="onSubmit" :loading="submitting">立即提交</el-button>
										<el-button @click="resetForm">重置</el-button>
									</div>
								</el-col>
							</el-row>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import UploadFileSingle from '@/components/UploadFileSingle/index.vue';
	import VDistpicker from 'v-distpicker';
	import dataProvince from '@/data/provinceSource.js';
	import { getSendVerifyCode, postVerifyCode } from '@/api/user/verifyCode.js';
	import TMessage from '@/utils/TMessage';
	import { mapGetters, mapActions } from 'vuex';
	import { postApplyCorporate, getCompanyType, getOriginType, getAccountType } from '@/api/user/apply';
	import { postMemberPhoneOld } from '@/api/user/user';

	export default {
		data() {
			// 自定义验证器 - 统一社会信用代码
			const validateCreditCode = (rule, value, callback) => {
				if (value) {
					// 统一社会信用代码正则表达式
					if (!/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value)) {
						callback(new Error('请输入正确的18位统一社会信用代码'));
					} else {
						callback();
					}
				} else {
					callback();
				}
			};

			// 自定义验证器 - 手机号码
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入联系人手机号码'));
				} else if (!/^1[3-9]\d{9}$/.test(value)) {
					callback(new Error('请输入正确的手机号码'));
				} else {
					callback();
				}
			};

			// 自定义验证器 - 验证码
			const validateCode = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入验证码'));
				} else if (!/^\d{6}$/.test(value)) {
					callback(new Error('验证码格式不正确'));
				} else {
					callback();
				}
			};

			return {
				loading: false,
				submitting: false,
				showAddressErrMsg: false,
				provinceSource: [],
				placeholders: {
					province: '请选择省',
					city: '请选择市',
					area: '请选择区'
				},
				//账号类别
				accountCountOptions: [],
				//来源类别
				channelOptions: [],
				//企业类型
				companyTypeOptions: [],
				waitNum: 0,
				wtimer: null,
				form: {
					sourceFind: '', // 了解途径
					corporateName: '', // 企业全称
					miniName: '', // 企业简称
					provinceName: '', // 省
					cityName: '', // 市
					districtName: '', // 区
					creditCode: '', // 统一社会信用代码
					companyType: '', // 企业类型
					accNeed: '', // 账号数量需求
					contactPerson: '', 
					contactPhone: '', // 联系人手机号码
					verifyCode: '', // 验证码
					verifyKey: '' // 验证码key
				},
				businessLicenseFile: '', // 用于UploadFileSingle组件绑定
				rules: {
					corporateName: [
						{ required: true, message: '请输入企业全称', trigger: 'blur' },
						{ min: 2, max: 100, message: '企业全称长度在 2 到 100 个字符', trigger: 'blur' }
					],
					miniName: [
						{ min: 2, max: 100, message: '企业简称长度在 2 到 100 个字符', trigger: 'blur' }
					],
					contactPerson: [
						{ min: 1, max: 50, message: '联系人姓名长度在 1 到 50 个字符', trigger: 'blur' }
					],
					creditCode: [{ validator: validateCreditCode, trigger: 'blur' }],
					contactPhone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
					verifyCode: [{ required: true, validator: validateCode, trigger: 'blur' }],
					companyType: [{ required: true, message: '请选择企业类型', trigger: 'change' }]
				}
			};
		},
		components: {
			UploadFileSingle,
			VDistpicker
		},
		methods: {
			...mapActions('Settings', ['setLoginShow', 'setLoginShowEnterprise']),

			handleLogin() {
				this.setLoginShowEnterprise(true);
			},

			// 营业执照上传变化
			handleBusinessLicenseChange(fileUrl) {
				const prefix = '/third/files/info/';
				const key = fileUrl.replace(prefix, '');
				this.form.verifyDoc = key;
			},

			// 发送验证码
			toSendMsg() {
				// 校验除验证码外的所有必填项
				const verifyCodeRule = this.rules.verifyCode;
				this.rules.verifyCode = [];
				this.$refs.form.validate(async valid => {
					this.rules.verifyCode = verifyCodeRule;
					if (valid) {
						try {
							this.startWait();
							const res = await getSendVerifyCode(this.form.contactPhone);
							if (res.code === 200) {
								this.form.verifyKey = res.data;
								TMessage.success('验证码已发送');
							} else {
								this.stopWait();
								TMessage.warning(res.msg || '短信发送失败');
							}
						} catch (error) {
							this.stopWait();
							TMessage.error('发送验证码失败');
						}
					} else {
						TMessage.warning('请完善必填信息');
					}
				});
			},

			// 开始倒计时
			startWait() {
				this.waitNum = 60;
				if (this.wtimer) {
					this.stopWait();
				}
				this.wtimer = setInterval(() => {
					this.waitNum--;
					if (this.waitNum <= 0) {
						this.stopWait();
					}
				}, 1000);
			},

			// 停止倒计时
			stopWait() {
				clearInterval(this.wtimer);
				this.wtimer = null;
				this.waitNum = 0;
			},

			// 省份选择变化
			selectChangeProvince(data) {
				this.form.cityName = '';
				this.form.districtName = '';
			},

			// 城市选择变化
			selectChangeCity(data) {
				this.form.districtName = '';
			},

			// 省市区选择完成
			onSelected(data) {
				const { province, city, area } = data;
				if (!province.code && !city.code && !area.code) return;
				this.form.provinceName = province.value;
				this.form.cityName = city.value;
				this.form.districtName = area.value;
				this.form.address = `${province.value}${city.value}${area.value}`;
				this.showAddressErrMsg = false;
			},

			// 提交表单
			onSubmit() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.submitting = true;

						// 验证码正确，继续提交
						if (!this.form.sourceFind) this.form.sourceFind = 0;
						if (!this.form.accNeed) this.form.accNeed = 0;

						postApplyCorporate(this.form)
							.then(res => {
								if (res.code == 200) {
									this.$message.success('企业账号申请已成功提交，请等待审核！');
									this.resetForm();
								} else {
									this.$message.error(res.msg || '申请提交失败');
								}
							})
							.catch(() => {
								this.$message.error('申请提交失败，请稍后重试');
							})
							.finally(() => {
								this.submitting = false;
							});

						// 先校验验证码是否正确
						// postVerifyCode({
						// 	phone: this.form.contactPhone,
						// 	verifyCode: this.form.verifyCode,
						// 	verifyKey: this.form.verifyKey
						// })
						// 	.then(resVerify => {
						// 		if (resVerify.code !== 200) {
						// 			this.submitting = false;
						// 			this.$message.warning(resVerify.msg || '验证码校验失败');
						// 			return;
						// 		}
						// 		if (!this.form.sourceFind) this.form.sourceFind = 0;
						// 		if (!this.form.accNeed) this.form.accNeed = 0;

						// 		postApplyCorporate(this.form)
						// 			.then(res => {
						// 				if (res.code == 200) {
						// 					this.$message.success('企业账户申请已成功提交，请等待审核！');
						// 					this.resetForm();
						// 				} else {
						// 					this.$message.error(res.msg || '申请提交失败');
						// 				}
						// 			})
						// 			.catch(() => {
						// 				this.$message.error('申请提交失败，请稍后重试');
						// 			})
						// 			.finally(() => {
						// 				this.submitting = false;
						// 			});
						// 	})
						// 	.catch(() => {
						// 		this.submitting = false;
						// 		this.$message.error('验证码校验失败，请稍后重试');
						// 	});
					} else {
						this.$message.warning('请完善必填信息');
					}
				});
			},

			// 重置表单
			resetForm() {
				this.$refs.form.resetFields();
				this.form = {
					corporateName: '',
					miniName: '',
					provinceName: '',
					cityName: '',
					districtName: '',
					creditCode: '',
					companyType: '',
					businessLicense: '',
					accNeed: '',
					sourceFind: '',
					contactPerson: '',
					contactPhone: '',
					verifyCode: '',
					verifyKey: ''
				};
				this.businessLicenseFile = '';
				this.showAddressErrMsg = false;
				this.stopWait();
				// 清空文件上传组件
				if (this.$refs.businessLicenseRef) {
					this.$refs.businessLicenseRef.clearFileList();
				}
			},

			// 获取账号类别
			async fetchAccountType() {
				try {
					const res = await getAccountType();
					if (res.code === 200 && res.data) {
						this.accountCountOptions = res.data;
					}
				} catch (error) {
					console.error('获取账号类别失败', error);
				}
			},

			// 获取来源类别
			async fetchOriginType() {
				try {
					const res = await getOriginType();
					if (res.code === 200 && res.data) {
						this.channelOptions = res.data;
					}
				} catch (error) {
					console.error('获取来源类别失败', error);
				}
			},

			// 获取企业类型
			async fetchCompanyType() {
				try {
					const res = await getCompanyType();
					if (res.code === 200 && res.data) {
						this.companyTypeOptions = res.data;
					}
				} catch (error) {
					console.error('获取企业类型失败', error);
				}
			}
		},

		beforeDestroy() {
			this.stopWait();
		},

		created() {
			// 页面初始化，加载省份数据
			this.provinceSource = dataProvince;
			// 加载下拉选项数据
			this.fetchAccountType();
			this.fetchOriginType();
			this.fetchCompanyType();
		}
	};
</script>

<style lang="less" scoped>
	.wrap-80 {
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.info-wrap {
		// margin-left: 20px;
		padding: 20px 0;
		font-size: 14px;
		color: #686f83;
		line-height: 1.8;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		min-height: calc(100vh - 120px);
		// max-width: 1200px;
		// min-width: 780px;
		// margin: 0 auto;

		/deep/ .el-form-item__label {
			font-size: 16px;
			color: #262626;
			font-weight: 600;
		}

		h3 {
			margin: 0 0 10px;
			font-size: 24px;
			color: #262626;
			font-weight: 700;
		}

		.login-tips {
			margin: 0;
			font-size: 16px;
			color: #333333;
			position: absolute;
			right: 10%;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px solid #cccccc;
		position: relative;
		margin-top: 20px;
		.topbox {
			color: #888888;
			dd {
				margin: 0 30px 0 0;
			}
		}
		.info-head-desc {
			font-size: 16px;
			color: #787878;
			margin: 0;
			margin-bottom: 20px;
		}
	}
	.info-content {
		text-indent: 2em;
	}
	.upload-tip {
		color: #909399;
		font-size: 12px;
		margin-top: 5px;
	}

	.field-businessLicense {
		display: flex;
		align-items: center;
		gap: 10px;

		h3 {
			margin: 0;
			font-size: 16px;
			color: #262626;
			font-weight: 600;
		}
	}

	.field-hint {
		color: #262626;
		font-size: 15px;
		margin-top: 4px;
		font-weight: normal;
	}

	// 验证码输入框样式
	.verify-code-input {
		display: flex;
		gap: 12px;

		.el-input {
			flex: 1;
		}

		.send-code-btn {
			white-space: nowrap;
			min-width: 110px;
			font-size: 14px;
		}
	}

	// 必填项红色星号样式
	/deep/ .el-form-item.is-required .el-form-item__label:before {
		content: '*';
		color: #f56c6c;
		margin-right: 4px;
	}

	// distpicker-wrapper样式，参考Element UI select
	/deep/ .distpicker-wrapper {
		display: flex;
		gap: 10px;
		align-items: center;
		margin-bottom: 22px;

		select {
			flex: 1;
			height: 40px;
			line-height: 40px;
			padding: 0 15px;
			background-color: #fff;
			background-image: none;
			border-radius: 4px;
			border: 1px solid #DCDFE6;
			color: #606266;
			font-size: inherit;
			outline: none;
			transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
			cursor: pointer;

			&:hover {
				border-color: #c0c4cc;
			}

			&:focus {
				border-color: #409eff;
			}

			&:disabled {
				background-color: #f5f7fa;
				border-color: #e4e7ed;
				color: #c0c4cc;
				cursor: not-allowed;
			}

			option {
				padding: 0;
			}
		}

		// 第一个select（省）宽度稍大
		select:first-child {
			flex: 1.2;
		}

		// 最后一个select（区/县）宽度稍小
		select:last-child {
			flex: 0.8;
		}
	}

	.flexStart {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
</style>
